export const APPEND_ERROR = 'APPEND_ERROR';
export const REMOVE_ERROR = 'REMOVE_ERROR';
